import React from 'react';
import backArrow from '../../../../../../assets/back.png';
import { Box, Table, TableCell, TableHeader, TableRow, TableBody, Text } from 'grommet';
import { useStore } from '../../../../../../Hooks/useStore';
import reportFlowSheet from '../../../../../../assets/flowsheet.svg';
import imageFile from '../../../../../../assets/photo.svg';
import './ReportList.css';
import Utility from '../../../../../../util/api/Utility';

const ReportList = () => {
    const { rootStore } = useStore();

    const handleReportListClose = () => {
        rootStore.emsStore.setReportList(); 
        rootStore.emsStore.setSeeAll(false)
      }

    const showImage = (src) => {
        rootStore.emsStore.handleReportImageState({showImage: true, imageUrl: src})
    }

    const getTimeWithInfo = (hourCount) => {
        if (hourCount > 12) {
            return "am";
        } else {
            return "pm"
        }
    }

    // const getPrettyTime = (time) => {
    //     console.log("import1",time)
    //     let timeParts = time.split(":");
    //     let hours = timeParts[0];
    //     let minutes = timeParts[1];
    //     let timeDesc = getTimeWithInfo(hours);
    //     return hours + ":" + minutes + " " + timeDesc;
    // }

    const getPrettyTime = (date) => {
        let formattedTime = Utility.getFormatedTime(date);
        console.log("formattedTime",formattedTime);
        return formattedTime;
      };

    return(
        <Box className="report-list-show">
            <Box className="reportTitle" style={{justifyContent: rootStore.emsStore.getSeeAll ? "space-between" : "center"}}>
                <Box className="report-cards-title">
                    <img src={reportFlowSheet} alt="report flow sheet" style={{height: 16, width: 16}} />
                    <Text className="report-main-title">{rootStore.emsStore.getReportTitle}</Text>
                </Box>
                {
                    rootStore.emsStore.getSeeAll
                        &&
                    <button onClick={handleReportListClose} className="report-modal-close"><img style={{width: 12,marginRight: 6}} src={backArrow} /><span>Back</span></button>
                }
            </Box>
            <Box className="table-outer">
            <Table>
                <TableHeader className='table-header'>
                    <TableRow>
                        <TableCell scope="col">S.No.</TableCell>
                        <TableCell scope="col">Time</TableCell>
                        <TableCell scope="col">File</TableCell>
                    </TableRow>
                </TableHeader>
                <TableBody className='table-body'>
                    {
                        rootStore.emsStore.getFilterReportList.map((report, index) => {
                            return(
                                <TableRow>
                                    <TableCell>{index + 1}</TableCell>
                                    <TableCell>{getPrettyTime(report.formattedLastModified)}</TableCell>
                                    <TableCell>
                                        <img onClick={() => showImage(report.imageUrl)} className='image-file-icon' src={imageFile} alt='image file icon' />
                                    </TableCell>
                                </TableRow>
                            )
                        })
                    }
                </TableBody>
            </Table>
            </Box>
    </Box>
    )
}

export default ReportList;